import { IPlan, Plan } from './plan';

export interface IUserPlan {
  expire_date?: string;
  expire_revalidation_date?: string;
  last_action_date?: string;
  need_partners?: number;
  pay_date?: string;
  name?: string;
  plan_id?: IPlan;
  plan_index?: number;
}

export class UserPlan {
  expire_date: Date;
  expire_revalidation_date: Date;
  last_action_date: Date;
  name: string;
  need_partners: number;
  pay_date: Date;
  currentPlan: Plan;
  plan_index: number;

  constructor( data: IUserPlan = {} ) {
    this.expire_date = data.expire_date ? new Date(data.expire_date) : null;
    this.expire_revalidation_date = data.expire_revalidation_date ? new Date(data.expire_revalidation_date) : null;
    this.last_action_date = data.last_action_date ? new Date(data.last_action_date) : null;
    this.need_partners = data.need_partners;
    this.pay_date = data.pay_date ? new Date(data.pay_date) : null;
    this.plan_index = data.plan_index;
    this.currentPlan = data.plan_id ? new Plan(data.plan_id) : null;
  }
}



// WEBPACK FOOTER //
// ./app/core/entities/user-plan.ts